import { render } from "./bmTopicInfo.vue?vue&type=template&id=e234934a&scoped=true"
import script from "./bmTopicInfo.vue?vue&type=script&lang=js"
export * from "./bmTopicInfo.vue?vue&type=script&lang=js"

import "./bmTopicInfo.vue?vue&type=style&index=0&id=e234934a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e234934a"]])

export default __exports__